import { securePaymentApi } from "@/service/axios";

const path = "business/business-registration-link";
class BusinessValidationLinkService {
    // async register(payload) {
    //     try {
    //         const data = await securePaymentApi.post(`${path}/register`, payload);
    //         return data;
    //     } catch (error) {
    //         throw error;
    //     }
    // }

    async isValidLink(link) {
        try {
            const data = await securePaymentApi.get(`${path}/is-valid-link/${link}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getLinkData(link) {
        try {
            const data = await securePaymentApi.get(`${path}/get-link-data/${link}`);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
      try {
        const data = await securePaymentApi.post(`${path}/update`, params);
        return data;
      } catch (err) {
        throw err;
      }
    }
}
export default new BusinessValidationLinkService();